export let WhenOptions = [
  {
    id: 1,
    name: "checkout.as_soon",
    description: "Soon",
    icon: "mdi-clock-check-outline",
    message: "checkout.as_soon_description",
  },
  {
    id: 2,
    name: "checkout.schedule",
    description: "checkout.schedule_description",
    icon: "mdi-calendar-clock",
    message: "checkout.schedule_date_time",
  },
];
